<template>
  <div>
    <b-modal
      :active="is_edit_feature"
      scroll="keep"
      @close="is_edit_feature = false"
    >
      <div class="card" style="border-radius: 1rem">
        <div class="card-content" style="padding: 10px">
          <div style="margin-bottom: 10px">
            Sorting ::
            <select v-model="sorting_type">
              <option value="vertical">Vertical</option>
              <option value="horizontal">Horizontal</option>
            </select>
            <select style="margin-left: 10px" v-model="sorting_order">
              <template v-if="sorting_type == 'vertical'">
                <option value="desc">Top to bottom</option>
                <option value="asc">Bottom to top</option>
              </template>
              <template v-else>
                <option value="asc">Left to right</option>
                <option value="desc">Right to left</option>
              </template>
            </select>
          </div>
          <input
            placeholder="Enter column name"
            class="input"
            v-if="is_new_column"
            type="text"
            v-model="column_name"
            @keyup.enter="add_new_column()"
          />
          <input
            placeholder="Enter column name"
            class="input"
            v-if="is_rename_column"
            type="text"
            v-model="column_name"
            @keyup.enter="update_rename_column()"
          />
          <!-- <i
            class="fa fa-arrow-right is-pointer"
            v-if="sorting == 'asc'"
            @click="sorting = 'desc'"
            aria-hidden="true"
            v-tooltip="'left to right'"
          ></i>
          <i
            class="fa fa-arrow-left is-pointer"
            @click="sorting = 'asc'"
            v-else
            aria-hidden="true"
            v-tooltip="'right to left'"
          ></i>

          <i
            class="fa fa-arrow-up is-pointer"
            v-if="sorting == 'asc'"
            @click="sorting = 'desc'"
            aria-hidden="true"
            v-tooltip="'top to bottom'"
          ></i>
          <i
            class="fa fa-arrow-down is-pointer"
            @click="sorting = 'asc'"
            v-else
            aria-hidden="true"
            v-tooltip="'bottom to top'"
          ></i> -->

          <p style="margin-top: 10px"></p>
          <div
            v-if="is_loading"
            class="has-text-centered"
            style="height: 50vh; padding-top: 5rem"
          >
            <i class="fa fa-spinner fa-spin"></i>
          </div>
          <hot-table
            v-else
            ref="hotTableComponent"
            class="has-slimscroll-xs"
            :licenseKey="'db092-91fce-a1a62-ecb33-e755b'"
            :settings="hotSettings"
            :data="filtered"
            :columns="columns"
            :colHeaders="colHeaders"
            height="450"
            width="650"
            :columnSorting="{
              sortEmptyCells: true,
            }"
            :manualColumnFreeze="true"
            :fixedColumnsLeft="2"
            :allowInsertColumn="true"
            :manualColumnResize="true"
          />
          <div class="bottom-buttons">
            <div class="is-flex">
              <div
                class="button"
                style="margin-right: 10px"
                @click="
                  () => {
                    $refs.csvFileInput.click();
                  }
                "
              >
                Import
              </div>
              <div class="button" @click="onExportClicked">Export</div>
            </div>
            <div class="is-flex">
              <div
                class="button"
                style="margin-right: 10px"
                @click="is_edit_feature = false"
              >
                Cancel
              </div>
              <div class="button is-primary" @click="saveChanges">Save</div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <input
      ref="csvFileInput"
      style="visibility: hidden"
      type="file"
      accept=".csv"
      @change="onImportInputChange"
    />
  </div>
</template>

<script>
import { HotTable } from "@handsontable/vue";
import { mapState } from "vuex";
import APIService from "@/services/api.service";
const apiService = new APIService();

export default {
  components: { HotTable },
  data() {
    return {
      sorting_type: "vertical",
      sorting_order: "asc",

      sorting: "asc",
      is_loading: true,
      is_rename_column: false,
      is_new_column: false,
      old_column_name: "",
      column_name: "",
      is_edit_feature: false,
      data: [],
      key: 1,
      colHeaders: [],
      columns: [],
      centroid_map: {},
      hotSettings: {
        copyPaste: {
          columnsLimit: 10000,
          rowsLimit: 9999999,
        },
        allowInsertColumn: true,
        dropdownMenu: {
          items: {
            rename: {
              name: "Rename",
              callback: this.rename_column,
            },
            delete: {
              name: "Delete",
              callback: this.delete_column,
            },
            add_new_column: {
              name: "Insert column",
              callback: (key, selection, clickEvent) => {
                this.is_new_column = true;
              },
            },
          },
        },
      },
    };
  },
  created() {
    document.addEventListener("click", (event) => {
      event.stopPropagation();
      if (
        event.target.id == "btn-edit" ||
        (event.target.parentNode && event.target.parentNode.id == "btn-edit")
      ) {
        let features = this.draw.getSelected().features;
        if (features.length > 1) {
          this.centroid_map = {};
          features.forEach((f) => {
            this.centroid_map[f.properties.uid] =
              turf.centroid(f).geometry.coordinates;
          });

          this.is_edit_feature = true;
          this.data = [];

          let query = "json=true";
          this.is_loading = true;
          apiService
            .getExtraPropsData({
              container_id: this.container.uid,
              query: "json=true",
              method: "POST",
              body: {
                uids: features.map((element) => element.properties.uid),
              },
            })
            .then((res) => {
              this.data = res.data;

              let colh = Object.assign({}, res.data[0]);
              delete colh.uid;
              delete colh.name;
              this.colHeaders = ["uid", "name"];
              this.colHeaders.push(...Object.keys(colh));
              this.columns = [];
              this.colHeaders.forEach((el) => {
                this.columns.push({
                  data: el,
                  readOnly: el === "uid",
                });
              });

              this.is_loading = false;
            })
            .catch((err) => {
              this.is_loading = false;
            });
        }
      }
    });
  },
  computed: {
    ...mapState(["draw", "container", "active_project"]),
    filtered() {
      let index_to_use = this.sorting_type === "horizontal" ? 0 : 1;
      return this.data.sort((a, b) => {
        if (this.sorting_order == "asc")
          return (
            this.centroid_map[a.uid][index_to_use] -
            this.centroid_map[b.uid][index_to_use]
          );
        return (
          this.centroid_map[b.uid][index_to_use] -
          this.centroid_map[a.uid][index_to_use]
        );
      });
    },
  },
  methods: {
    add_new_column() {
      this.colHeaders.push(this.column_name);
      this.columns.push({ data: this.column_name });
      this.data = this.data.map((el) => {
        el[this.column_name] = "";
        return el;
      });
      this.is_new_column = false;
      this.saveChanges();
    },
    update_rename_column() {
      this.colHeaders[
        this.colHeaders.findIndex((k) => k === this.old_column_name)
      ] = this.column_name;

      this.columns[
        this.columns.findIndex((el) => el.data === this.old_column_name)
      ].data = this.column_name;

      this.data = this.data.map((e) => {
        let el = Object.assign({}, e);
        el[this.column_name] = el[this.old_column_name];
        delete el[this.old_column_name];
        return el;
      });
      this.is_rename_column = false;
      this.saveChanges();
    },
    delete_column(keyy, selection) {
      let key = this.colHeaders[selection[0].start.col];

      if (key == "uid" || key == "name") return;

      let c = confirm("Are you sure?");
      if (!c) return;
      this.colHeaders = this.colHeaders.filter((el) => el !== key);
      this.columns = this.columns.filter((el) => el.data !== key);
      this.data = this.data.map((el) => {
        delete el[key];
        return el;
      });
    },
    rename_column(key, selection) {
      this.old_column_name = this.colHeaders[selection[0].start.col];

      if (this.old_column_name == "uid" || this.old_column_name == "name")
        return;
      this.is_rename_column = true;

      this.column_name = this.colHeaders[selection[0].start.col];
    },
    saveChanges() {
      let res = apiService
        .getExtraPropsDataSave({
          container_id: this.container.uid,
          query: "json=true",
          body: this.data,
        })
        .then((res) => {
          let response = {};
          (res.data || []).forEach((el) => {
            response[el.uid] = el;
          });

          let fc = this.draw.getAll();
          fc.features = fc.features.map((f) => {
            if (response[f.properties.uid]) {
              f.properties.name = response[f.properties.uid].name;
              f.properties.extraProperties = {
                ...f.properties.extraProperties,
                ...response[f.properties.uid].extraProperties,
              };
            }
            return f;
          });

          this.draw.add(fc);
          this.$toast.open("Saved successfully");
          this.is_edit_feature = false;
        })
        .catch((err) => {
          console.log(err);
          this.$toast.open(`Failed to save changes. Error: ${err}`);
        });
    },
    onImportInputChange(event) {
      if (
        !window.File ||
        !window.FileReader ||
        !window.FileList ||
        !window.Blob
      ) {
        console.log("The File APIs are not fully supported in this browser.");
        return;
      }

      if (!event.target.files) {
        console.log(
          "This browser doesn't seem to support the `files` property of file inputs."
        );
      } else if (!event.target.files[0]) {
        console.log("No file selected.");
      } else {
        let file = event.target.files[0];
        let fr = new FileReader();
        fr.onload = () => {
          const cell_contents = fr.result
            .replace(/\r/g, "")
            .replace(/\n/g, ",")
            .split(",");
          const chunked_array = _.chunk(cell_contents, this.colHeaders.length);
          const result = _.chain(chunked_array)
            .map((p) => {
              return _.zipObject(this.colHeaders, p);
            })
            .value();
          this.$refs.hotTableComponent.hotInstance.loadData(result);
        };
        fr.readAsText(file);
      }
    },
    onExportClicked() {
      const hot = this.$refs.hotTableComponent.hotInstance;
      const exportPlugin = hot.getPlugin("exportFile");
      exportPlugin.downloadFile("csv", { filename: "export" });
    },
  },
};
</script>
<style lang="scss">
@import "~handsontable/dist/handsontable.full.css";
</style>

<style lang="scss" scoped>
::v-deep .modal .modal-content {
  width: 670px;
}

.bottom-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
}
</style>
